export default __webpack_public_path__ + "static/logo-67c0376312d00b11ae7b7b2c913a2b42.png";